module.exports = __webpack_public_path__ + "media/images/shop-dashboard-menu-icon-8876984029ba25bf7bd4f50e41e8b2b4.png";